import { render, staticRenderFns } from "./Play_Apply3.vue?vue&type=template&id=3c507634&scoped=true"
import script from "./Play_Apply3.vue?vue&type=script&lang=js"
export * from "./Play_Apply3.vue?vue&type=script&lang=js"
import style0 from "./Play_Apply3.vue?vue&type=style&index=0&id=3c507634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c507634",
  null
  
)

export default component.exports